import AddToWishListView from './views/add-to-wishlist.js';

export default class AddToWishList{
	constructor({
		el,
		product_id,
		logged_user,
		in_wishlist
	}) {
		this.view = new AddToWishListView({
			el,
			product_id,
			logged_user,
			in_wishlist
		});
	}
}
